import * as React from 'react';
import { Upload } from 'components/icons';
import UpsellBanner, { UpsellBannerProps } from 'components/UpsellBanner';
import { DEFAULT_UPGRADE_UPLOAD_LIMIT } from 'utils/constants';

export interface FileSizeUpsellProps
  extends Pick<UpsellBannerProps, 'onUpgradeClick'> {
  className?: string;
  upgradeLimit?: string;
}

const FileSizeUpsellBanner: React.FC<FileSizeUpsellProps> = ({
  className,
  onUpgradeClick,
  upgradeLimit = DEFAULT_UPGRADE_UPLOAD_LIMIT,
}) => (
  <UpsellBanner
    {...{ className, onUpgradeClick }}
    heading={`Increase your upload limit to ${upgradeLimit}`}
    actionLabel="Upgrade now"
    icon={<Upload />}
  />
);

export default FileSizeUpsellBanner;
